import { Field } from '@sitecore-jss/sitecore-jss-react';
import { ProductType } from '../utils/ProductTypes';

export type ProductConfigurationProps = {
  displayName: string;
  fields: {
    ProductIdentifier: Field<string>;
    HasEdition?: Field<Boolean>;
    HasPriceOptions?: Field<boolean>;
    HasSessionOptions?: Field<Boolean>;
    HasModality?: Field<Boolean>;
    HasCountryRestrictions: Field<Boolean>;
  };
};

export function getProductTypeConfig(
  productType: string,
  productConfigurations: ProductConfigurationProps[]
): ProductConfigurationProps | undefined {
  if (!productType) {
    return undefined;
  }

  return productConfigurations?.find(
    (config) => config.fields?.ProductIdentifier?.value?.toLowerCase() === productType.toLowerCase()
  );
}

export const PATH_TO_PRODUCT_TYPE: Record<string, ProductType> = {
  datasheets: ProductType.Datasheet,
  standards: ProductType.Standard,
  statisticsreports: ProductType.StatisticsReport,
  'self-paced-courses': ProductType.TrainingCourses,
  'instructor-led-courses': ProductType.TrainingCourses,
};

export const PRODUCT_TYPE_TO_PATH: Record<string, string> = {
  [ProductType.Standard]: 'standards',
  [ProductType.Datasheet]: 'datasheets',
  [ProductType.StatisticsReport]: 'statisticsreports',
  [ProductType.SelfPacedCourse]: 'self-paced-courses',
  [ProductType.InstructorLedCourse]: 'instructor-led-courses',
};
